<template>
    <li @click="initEditPoll">
        <a href="#">
            <i class="fa fa-poll-h"></i> {{ translations['fields.edit'] }} poll
        </a>
    </li>
</template>

<script>
    import {mapState} from 'vuex';
    import Global from '../../mixins/Global.js'

    export default {
        mixins: [Global],

        props: ['quizId'],

        data() {
            return {
                poll_settings: []
            }
        },

        computed: {
            ...mapState(['modalData']),

            poll: {
                get() {
                    return this.$store.getters['poll/getPollById'](this.quizId);
                },

                set(poll) {
                    this.$set(this.$store.getters['poll/getPollById'](this.quizId).questions, 0, poll);
                }
            },
        },

        methods: {
            initEditPoll() {
                let self = this;

                //set topic data for editing
                let pollData = {
                    topContent: this.translations['forum.edit_poll'],
                    icon: 'fa fa-poll-h',
                    poll: this.poll.questions[0],
                    poll_id: this.poll.id,
                };

                //set edit topic modal data
                this.$store.commit('setModalData', {
                    modalName: 'EditPoll',
                    modalData: pollData,

                    modalSubmitEmit() {
                        self.$store.dispatch('poll/updatePoll', self.modalData.poll).then((result) => {
                            self.poll = result;

                            let settings_data = {};
                            settings_data.settings = [];

                            Object.keys(self.modalData.settings).map(function (key, index) {
                                settings_data.settings.push({
                                    'setting': key,
                                    'value': self.modalData.settings[key]
                                })
                            });

                            if(self.modalData.end_date) {
                                settings_data.settings.push({
                                    'setting': 'end_date',
                                    'value': moment(self.modalData.end_date).format('YYYY-MM-DD HH:mm:ss'),
                                })
                            }

                            //update and sync new settings
                            self.$store.dispatch('poll/updatePollSettings', {poll_id: self.poll.id, settings: settings_data}).then(() => {
                                window.location.reload();
                            });
                        });
                    }
                });
            },
        }
    }
</script>